import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency: string = 'Frw'): string {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return '0.00 Frw'
  }
  // Format as "Amount Frw" (e.g., "1,000.00 Frw")
  if (currency === 'Frw' || currency === 'FRW' || currency === 'RWF') {
    return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Frw`
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount)
}

/**
 * Formats error messages to be more user-friendly, especially for network errors
 */
export function formatErrorMessage(error: any): string {
  if (!error) {
    return 'An unexpected error occurred'
  }

  const errorMessage = error?.message || error?.toString() || String(error)
  const errorString = errorMessage.toLowerCase()

  // Network/Connection errors
  if (
    errorString.includes('failed to fetch') ||
    errorString.includes('networkerror') ||
    errorString.includes('network error') ||
    errorString.includes('fetch') ||
    errorString.includes('network') ||
    errorString.includes('connection') ||
    errorString.includes('timeout') ||
    errorString.includes('aborted') ||
    error instanceof TypeError && error.message.includes('fetch')
  ) {
    return 'No internet connection. Please check your network and try again.'
  }

  // Timeout errors
  if (errorString.includes('timeout') || errorString.includes('timed out')) {
    return 'Request timed out. Please check your internet connection and try again.'
  }

  // Return the original message if it's already user-friendly
  return errorMessage
}
